import { forwardRef } from 'react';
import type { ScaleOrdinal } from 'd3-scale';
import { VisxText } from '@/components/VisxText';

interface Props {
  color: ScaleOrdinal<string, string>;
  keys: string[];
  /**
   * A set of labels to display for each key.
   * If not provided the keys themselves will be displayed directly.
   *
   * Added as a backward-compatible way to support localised labels.
   */
  keyLabels?: string[];
  xScale: ScaleOrdinal<string, number>;
  y: number;
  showEmptyState?: boolean;
}

const Axis = forwardRef<SVGSVGElement, Props>(
  ({ y, xScale, keys, keyLabels, color, showEmptyState }, ref) => {
    const labels = keyLabels !== undefined ? keyLabels : keys;
    return (
      <svg x="-4" y={y} width="100%" ref={ref}>
        {keys.map((key, i) => (
          <VisxText
            key={`axis-${key}`}
            dx={`${xScale(key) * 100}%`}
            dy={4}
            verticalAnchor="start"
            textAnchor="end"
            fill={color(key)}
            angle={-35}
            typography="xSmallStrong"
          >
            {showEmptyState ? labels[i]?.replace('20% ', '') : labels[i]}
          </VisxText>
        ))}
      </svg>
    );
  }
);

Axis.displayName = 'Axis';

export default Axis;
